import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import LineArrowsRightDownIcon from 'components/Luxkit/Icons/line/LineArrowsRightDownIcon'
import BodyTextBlock from 'components/Luxkit/TextBlocks/BodyTextBlock'
import React from 'react'

interface Props {
  packageRoomType: App.PackageRoomType
}

function AccommodationRoomDetailsList(props: Props) {
  const { packageRoomType } = props

  return <VerticalSpacer gap={4}>
    {packageRoomType.sizeSqm && <BodyTextBlock variant="medium" startIcon={<LineArrowsRightDownIcon />}>
      {packageRoomType.sizeSqm} m&sup2;
    </BodyTextBlock>}
  </VerticalSpacer>
}

export default AccommodationRoomDetailsList
